import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const MainDetailWrapper = styled.div`
  width: 100%;
`;

export const MainDetailContentWrapper = styled.div`
  padding-top: 32px;
  border-top: 1px solid #d2d6da;
  @media (${mediaQuery.tablet}) {
    margin: 0 24px;
  }
  ${media.xs`
    padding-top: 24px;
    margin: 0 16px;
  `};
  .detail-show-more {
    margin-bottom: 0;
  }
  .show-more-button {
    margin-top: 0;
    margin-bottom: 24px;
    ::before {
      display: none;
    }
  }
`;

export const MainDetailContent = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const MainDetailAttribute = styled.div`
  width: 50%;
  margin-bottom: 24px;
  font-size: 14px;
  p {
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${media.xs`
    width: 100%;
  `};
`;

export const MainDetailTitle = styled.p`
  margin: 0 0 4px;
  color: #697684;
  font-weight: 300;
  line-height: 1.43;
  letter-spacing: normal;
`;

export const MainDetailAttributeData = styled.p`
  margin: 0;
  color: #333f48;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: normal;
`;
